var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  x: 3,
  y: 38.5,
  width: 39,
  height: 1.5,
  rx: 0.75,
  fill: "#c3ccd2"
});

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  x: 6,
  y: 9,
  width: 10,
  height: 29.5,
  rx: 1.5,
  fill: "#a7b2ba"
});

var _ref4 = /*#__PURE__*/React.createElement("rect", {
  x: 6,
  y: 18.5,
  width: 10,
  height: 1,
  fill: "#8f9ba3"
});

var _ref5 = /*#__PURE__*/React.createElement("rect", {
  x: 13.8,
  y: 12,
  width: 1.1,
  height: 4.5,
  rx: 0.55,
  fill: "#5c6870"
});

var _ref6 = /*#__PURE__*/React.createElement("rect", {
  x: 13.8,
  y: 21.5,
  width: 1.1,
  height: 6,
  rx: 0.55,
  fill: "#5c6870"
});

var _ref7 = /*#__PURE__*/React.createElement("rect", {
  x: 28,
  y: 6,
  width: 12,
  height: 7.5,
  rx: 1,
  fill: "#c8925a"
});

var _ref8 = /*#__PURE__*/React.createElement("rect", {
  x: 33.55,
  y: 6,
  width: 0.9,
  height: 7.5,
  fill: "#8a6238"
});

var _ref9 = /*#__PURE__*/React.createElement("circle", {
  cx: 32.3,
  cy: 10.2,
  r: 0.6,
  fill: "#5c6870"
});

var _ref10 = /*#__PURE__*/React.createElement("circle", {
  cx: 35.7,
  cy: 10.2,
  r: 0.6,
  fill: "#5c6870"
});

var _ref11 = /*#__PURE__*/React.createElement("rect", {
  x: 20.5,
  y: 17,
  width: 2.8,
  height: 9,
  fill: "#3f4a54"
});

var _ref12 = /*#__PURE__*/React.createElement("rect", {
  x: 20.5,
  y: 17,
  width: 6.2,
  height: 2.6,
  rx: 1,
  fill: "#3f4a54"
});

var _ref13 = /*#__PURE__*/React.createElement("rect", {
  x: 20.5,
  y: 24.3,
  width: 6.2,
  height: 1.7,
  rx: 0.8,
  fill: "#3f4a54"
});

var _ref14 = /*#__PURE__*/React.createElement("rect", {
  x: 23.6,
  y: 21,
  width: 2.9,
  height: 3.3,
  rx: 0.6,
  fill: "#4fb3c6"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "m26.5 21.7c1.3 0 1.3 2 0 2",
  fill: "none",
  stroke: "#4fb3c6",
  strokeWidth: 0.9
});

var _ref16 = /*#__PURE__*/React.createElement("rect", {
  x: 19.5,
  y: 28,
  width: 20.5,
  height: 10.5,
  fill: "#c8925a"
});

var _ref17 = /*#__PURE__*/React.createElement("rect", {
  x: 29.4,
  y: 28,
  width: 0.9,
  height: 10.5,
  fill: "#8a6238"
});

var _ref18 = /*#__PURE__*/React.createElement("circle", {
  cx: 35,
  cy: 33,
  r: 0.7,
  fill: "#5c6870"
});

var _ref19 = /*#__PURE__*/React.createElement("rect", {
  x: 19.5,
  y: 28,
  width: 9.9,
  height: 10.5,
  fill: "#a7b2ba"
});

var _ref20 = /*#__PURE__*/React.createElement("rect", {
  x: 20.3,
  y: 28.7,
  width: 8.3,
  height: 1.2,
  rx: 0.6,
  fill: "#5c6870"
});

var _ref21 = /*#__PURE__*/React.createElement("rect", {
  x: 20.3,
  y: 31,
  width: 8.3,
  height: 1,
  rx: 0.5,
  fill: "#8f9ba3"
});

var _ref22 = /*#__PURE__*/React.createElement("circle", {
  cx: 27.6,
  cy: 29.3,
  r: 0.35,
  fill: "#9fd8ef"
});

var _ref23 = /*#__PURE__*/React.createElement("rect", {
  x: 18.5,
  y: 26,
  width: 22.5,
  height: 2,
  rx: 1,
  fill: "#dfe6ec"
});

var _ref24 = /*#__PURE__*/React.createElement("rect", {
  x: 29,
  y: 26.4,
  width: 7.4,
  height: 2.6,
  rx: 0.9,
  fill: "#8f9ba3"
});

var _ref25 = /*#__PURE__*/React.createElement("rect", {
  x: 29.8,
  y: 26.9,
  width: 5.8,
  height: 1.6,
  rx: 0.5,
  fill: "#5c6870"
});

var _ref26 = /*#__PURE__*/React.createElement("rect", {
  x: 31.8,
  y: 24.2,
  width: 1.4,
  height: 2.2,
  fill: "#5c6870"
});

var _ref27 = /*#__PURE__*/React.createElement("path", {
  d: "m32.5 24.2v-2.2c0-1.5 1.2-2.7 2.7-2.7h0.8v2",
  fill: "none",
  stroke: "#5c6870",
  strokeWidth: 1.3,
  strokeLinecap: "round"
});

var _ref28 = /*#__PURE__*/React.createElement("circle", {
  cx: 38.7,
  cy: 24.9,
  r: 1.2,
  fill: "#c8503f"
});

var _ref29 = /*#__PURE__*/React.createElement("path", {
  d: "m38.7 23.7c0.2-0.7 0.7-1.1 1.4-1.1-0.1 0.7-0.6 1.1-1.4 1.1z",
  fill: "#57b368"
});

var _ref30 = /*#__PURE__*/React.createElement("path", {
  d: "m36 22.6c0 0 0.7 1.2 0.7 1.8 0 0.4-0.3 0.7-0.7 0.7s-0.7-0.3-0.7-0.7c0-0.6 0.7-1.8 0.7-1.8z",
  fill: "#9fd8ef"
});

function SvgOfficeKitchen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 45 45",
    viewBox: "0 0 45 45",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOfficeKitchen);
export default __webpack_public_path__ + "static/media/office-kitchen.c80ed488c7904d976ccc7ce59ff3d70e.svg";
export { ForwardRef as ReactComponent };